<template>
  <div class="kye-header-search">
    <el-input
      ref="searchMenu"
      v-model="searchKey"
      clearable
      placeholder="名称或首字母"
      class="kye-header-search__input"
      data-autocomplete="off"
      v-popover:popover
      @input="handleInput"
      @focus="handleFocus">
      <i slot="prefix" class="layout layout-search2" style="font-size: 12px"></i>
    </el-input>
    <el-popover
      ref="popover"
      v-model="visible"
      placement="bottom-start"
      width="200"
      popper-class="kye-header-search-popover"
      trigger="manual">
      <div class="kye-header-search-popover-content" ref="popoverContent">
        <div class="empty-box" v-show="(searchKey && !searchResults.length) || (!searchKey && !historyItems.length && !commomModuleListShow)">
          <span>未找到相关结果！</span>
        </div>
        <div class="search-results kye-scrollbar" ref="searchResultsList" v-show="searchResults.length">
          <div
            class="search-result-item"
            v-for="(item, index) in searchResults"
            :key="item.id"
            :class="{ 'search-result-item--active': index === highlightIndex || index === highlightIndexOfKeyboard, 'search-result-item--no-auth': !item.userChooseFlag }"
            @mouseenter="highlightIndex = index"
            @click="selectMenu(item)">
            <i class="layout layout-search2"></i>
            <p class="title">
              <template v-if="item.$matchInTitle">
                <span class="title-text" v-html="highlightText(item.$title, searchKey)"></span>
                <span v-if="item.$kyeWord" class="matched-keyword">
                  <span class="matched-keyword__paren">(</span>
                  <span class="matched-keyword__text" v-html="highlightText(item.$kyeWord, searchKey)"></span>
                  <span class="matched-keyword__paren">)</span>
                </span>
              </template>
              <template v-else>
                <span class="title-text">{{ item.$title }}</span>
                <span v-if="item.$kyeWord" class="matched-keyword">
                  <span class="matched-keyword__paren">(</span>
                  <span class="matched-keyword__text" v-html="highlightText(item.$kyeWord, searchKey)"></span>
                  <span class="matched-keyword__paren">)</span>
                </span>
              </template>
            </p>
            <p class="no-auth" v-if="!item.userChooseFlag">无权限</p>
            <p class="apply-auth" v-if="!item.userChooseFlag" @click="goApplyAuth(item)">申请权限</p>
          </div>
        </div>
        <div class="search-history" v-show="historyItems.length && (!searchKey || (searchKey && searchResults.length === 0))">
          <div class="search-history-title">
            <span>最近访问</span>
            <i class="el-icon-delete" @click="clearHistory"></i>
          </div>
          <div
            class="search-history-list"
            :style="{ maxHeight: historyListMaxHeight + 'px' }">
            <el-tooltip
              v-for="item in historyItems"
              :key="item.menuCode"
              :content="item.$title"
              effect="light"
              placement="bottom"
              popper-class="kye-header-search-history-tooltip">
              <div
                class="search-history-item"
                @click="selectHistoryMenu(item)">{{ item.title }}</div>
            </el-tooltip>
          </div>
        </div>
        <div class="module-box" v-show="commomModuleListShow">
          <CommonModuleList ref="commonModuleList" mode="dialog" class="module-box-list" @updateActiveTab="updateActiveTab" />
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
  import bus from 'public/utils/bus'
  import { HOME_MENUS } from 'public/config'
  import { getToken } from 'public/utils'
  import { QtReportOpenMenuBySearch } from '@/layout/utils/report-qt.js'
  import CommonModuleList from '@/layout/components/common-module-list/index.vue'
  import Pinyin from 'pinyin/lib/web-pinyin'
  const en = { style: Pinyin.STYLE_FIRST_LETTER, segment: false }
  const ERP_MENU_SELECTED = 'erp_menu_selected_v2'
  const MAX_SELECTED_MENU_CACHE = 20
  const HISTORY_MAX_ROWS = 2
  const HISTORY_ITEM_HEIGHT = 28
  const HISTORY_ROW_GAP = 12

  const HISTORY_MAX_HEIGHT = HISTORY_ITEM_HEIGHT * HISTORY_MAX_ROWS + HISTORY_ROW_GAP * (HISTORY_MAX_ROWS - 1)
  const formatMenuPathTitle = (menuPath) => {
    if (!menuPath) return ''
    const segments = menuPath.split('>')
    if (segments.length <= 1) return menuPath
    return segments.slice(1).join('>')
  }
  const on = (element, event, handler, options) => {
    element.addEventListener(event, handler, options)
  }


  const off = (element, event, handler, options) => {
    element.removeEventListener(event, handler, options)
  }

  export default {
    name: 'HeaderSearch',
    components: { CommonModuleList },
    data () {
      return {
        searchKey: '',
        visible: false,
        historyItems: [],
        searchResults: [],
        allMenus: [],
        highlightIndex: -1,
        highlightIndexOfKeyboard: -1, // 与鼠标hover 高亮区分开，避免高亮回跳
        historyListMaxHeight: HISTORY_MAX_HEIGHT,
        visibleMenu: true
      }
    },
    computed: {
      visitedViews () {
        return this.$store.state.tagsView.visitedViews
      },
      popperClass () {
        let str = 'kye-popper-auto'
        if (this.theme === 'dark') {
          str += ' kye-popper-auto_dark'
        }
        return str
      },
      commomModuleListShow () {
        if (!this.visible) return false
        if (!this.visibleMenu) return false
        if (this.$route.path === '/') return false
        if (this.searchKey) return !this.searchResults.length
        return true
      },
    },
    watch: {
      visible (val) {
        if (val) {
          this.handleOpen()
        } else {
          off(document, 'mousedown', this.handleDocumentClick)
        }
      }
    },
    // created () {
    //   this.init()
    // },
    mounted () {
      this.$bus.$once('APP_LOADED', this.init)
      // this.init()
      this.$bus.$on('GLOBAL_USE_OPEN_MODULE', this.handleClose)
      on(document, 'keydown', this.handleSearchKeydown)
    },
    beforeDestroy () {
      off(document, 'mousedown', this.handleDocumentClick)
      off(document, 'keydown', this.handleSearchKeydown)
    },
    methods: {
      init () {
        this.initAllMenus()
        // this.initHistoryItems()
      },
      focus() {
        this.$nextTick(() => {
          this.$refs.searchMenu.focus()
        })
      },
      handleClose() {
        this.visible = false
      },
      updateActiveTab (val) {
        this.visibleMenu = Boolean(val)
      },
      // 获取store 中的menu, 组装成可选菜单
      getChoiceMenuStore () {
        if (!this.$store.getters.menus) return []
        const storeMenus = Object.values(this.$store.getters.menus)
        const menuList = storeMenus.filter(v => v.$title && !HOME_MENUS.includes(v.menuCode))
        const canChooseMenus = menuList.map(v => {
          v.userChooseFlag = true
          return v
        })
        return canChooseMenus
      },
      async initAllMenus () {
        // 以权限菜单树接口为准，缓存中菜单数据兜底
        /**
         * userFlag：是否需要返回无用户权限的按钮，为true 时返回数据中会返回 userChooseFlag
         * userChooseFlag：用户是否有模块权限，有模块权限=true, 否则=false
         * chooseFlag：用户是否有数据权限(行|列权限)，有选择=true, 否则=false
         */
        let menuList = this.getChoiceMenuStore()
        const params = {
          groups: ['ERP'],
          userFlag: true,
          userChooseFlag: true,
          authFlag: true,
          chooseFlag: true,
          treeFlag: false,
          // userId: this.$store.state.user.id
        }
        // let menuList = []
        try {
          const resData = await this.$http('auth.manage.authMenuResources.menuTree', params, {
            'cancel': true, // 取消报错提示
            'log': false, // 取消上报日志
            axios: {
              headers: {
                'X-menu-id': '1055747388493336576',
              }
            }
          })
          // 过滤掉 getChoiceMenuStore 的数据。即以侧边栏菜单为第一优先，补充接口返回的无权限数据
          const filterStoreMenu = resData.filter(item => item.menuCode && !menuList.some(v => v.menuCode === item.menuCode))
          menuList = [...menuList, ...filterStoreMenu]
        } catch (error) {
          console.error('菜单树获取失败:', error)
        } finally {
          this.allMenus = menuList.filter(item => item.chooseFlag || item.userChooseFlag)
            .map(item => this.normalizeMenuItem(item))
        }
      },
      normalizeMenuItem (item) {
        const menuCode = item.menuCode || ''
        return {
          ...item,
          menuCode,
          $title: item.$title || formatMenuPathTitle(item.menuPath),
          title: item.title || item.name || item.menuTitle || '',
          $kyeWord: item.$kyeWord || item.keyWord || '',
          $title_en: Pinyin(item.title || item.menuTitle || item.name, en).map(v => v[0]).join('') || ''
        }
      },
      getMenuByCode (menuCode) {
        return this.$store.state.menus[menuCode]
      },
      handleOpen () {
        if (!this.searchKey) {
          this.searchResults = []
          this.highlightIndex = -1
          this.highlightIndexOfKeyboard = -1
        }
        this.$nextTick(() => {
          // 触发内部重新渲染
          this.$refs.commonModuleList.init()
          on(document, 'mousedown', this.handleDocumentClick)
        })
      },
      pushRoute (path, keyword = '') {
        if (!path || path.startsWith('http')) {
          this.openLink(path)
          QtReportOpenMenuBySearch(path)
          return
        }
        const route = this.$router.resolve(path).route
        route.meta.layout = true
        keyword && (route.meta.searchKeyword = keyword)
        const currentRoute = this.visitedViews.find(t => t.tag === path)
        bus.$emit('GLOBAL_USE_OPEN_MODULE', route.meta.tag || path)
        if (currentRoute) {
          const currentPathRoute = this.$router.resolve(currentRoute.path).route
          currentPathRoute && (currentPathRoute.meta.layout = true)
          this.$router.push(currentRoute.path)
          this.$bus.$emit('TAB_CLICK', currentRoute.path, currentRoute.tag)
          QtReportOpenMenuBySearch(currentRoute.path)
        } else {
          this.$router.push(path)
          this.$bus.$emit('TAB_CLICK', path, path)
          QtReportOpenMenuBySearch(path)
        }
      },
      escapeHtml (str) {
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
      },
      highlightText (text, keyword) {
        if (!text || !keyword) {
          return this.escapeHtml(text || '')
        }
        const escapedText = this.escapeHtml(text)
        const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const reg = new RegExp(`(${escapedKeyword})`, 'gi')
        return escapedText.replace(reg, '<span class="search-highlight">$1</span>')
      },
      searchMenu (val) {
        const res = []
        if (val) {
          const letter = /^[a-zA-Z]+$/
          const en = letter.test(val)
          this.allMenus.forEach(v => {
            const matchInTitle = v.$title.includes(val)
            const matchInTitleEn = en && v.$title_en && v.$title_en.includes(val)
            let keyword = v.$kyeWord ? v.$kyeWord.split(',') : []
            let matchedKyeWord = keyword.find(key => key.includes(val))

            if (matchInTitle || matchInTitleEn) {
              res.push({
                ...v,
                $matchInTitle: matchInTitle
              })
            } else if (matchedKyeWord) {
              res.push({
                ...v,
                $kyeWord: matchedKyeWord
              })
            }
          })
        }
        res.sort((a, b) => {
          if (!!a.userChooseFlag === !!b.userChooseFlag) return 0
          return a.userChooseFlag ? -1 : 1
        })
        this.searchResults = res
        this.highlightIndex = res.length > 0 ? 0 : -1
        this.highlightIndexOfKeyboard = -1
      },
      cacheSelectedMenu (val) {
        let selectedMenus = JSON.parse(localStorage.getItem(ERP_MENU_SELECTED)) || []
        const index = selectedMenus.findIndex(menu => menu.menuCode === val.menuCode)
        const menu = this.getMenuByCode(val.menuCode)
        const item = {
          menuCode: val.menuCode,
          $title: menu.$title,
          title: menu.title,
          $kyeWord: menu.$kyeWord
        }
        if (index !== -1) {
          selectedMenus.splice(index, 1)
        }
        selectedMenus.unshift(item)
        selectedMenus = selectedMenus.slice(0, MAX_SELECTED_MENU_CACHE)
        localStorage.setItem(ERP_MENU_SELECTED, JSON.stringify(selectedMenus))
        this.historyItems = selectedMenus
      },
      selectHistoryMenu (item) {
        this.pushRoute(item.menuCode)
        this.searchKey = ''
        this.cacheSelectedMenu(item)
        this.visible = false
      },
      selectMenu (val) {
        if (!val.userChooseFlag) {
          return
        }
        let key = ''
        try {
          key = this.$refs.searchMenu.$refs.input.value
        } catch (e) {
          console.error(e)
        }
        this.pushRoute(val.menuCode, key)
        this.searchKey = ''
        this.cacheSelectedMenu(val)
        this.visible = false
      },
      initHistoryItems () {
        let selectedMenus = JSON.parse(localStorage.getItem(ERP_MENU_SELECTED))
        if (Array.isArray(selectedMenus)) {
          const newSelectedMenus = selectedMenus.filter(v => this.getMenuByCode(v.menuCode)).map(item => {
            const menu = this.getMenuByCode(item.menuCode)
            return {
              menuCode: menu.menuCode,
              title: menu.title,
              $title: menu.$title,
              $kyeWord: menu.$kyeWord
            }
          })
          this.historyItems = newSelectedMenus
        }
      },
      clearHistory () {
        this.historyItems = []
        localStorage.removeItem(ERP_MENU_SELECTED)
        this.visible = false
      },
      handleFocus () {
        this.initHistoryItems()
        this.visible = true
      },
      focusSearch () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.searchMenu && this.$refs.searchMenu.focus()
        })
      },
      handleDocumentClick (e) {
        const target = e.target
        if (this.$el.contains(target)) {
          return
        }
        const popperEl = this.$refs.popover && this.$refs.popover.popperElm
        if (popperEl && popperEl.contains(target)) {
          return
        }
        this.visible = false
      },
      handleInput (val) {
        this.searchMenu(val)
      },
      handleSearchKeydown (e) {
        const hasResults = this.visible && this.searchResults.length
        if (e.key === 'ArrowDown') {
          if (!hasResults) return
          e.preventDefault()
          const currentIndexOfDn = this.highlightIndexOfKeyboard !== -1 ? this.highlightIndexOfKeyboard : this.highlightIndex
          this.highlightIndexOfKeyboard = (currentIndexOfDn + 1) % this.searchResults.length
          this.highlightIndex = -1 // 取消默认第一条高亮
          this.scrollIntoHighlight()
          return
        }
        if (e.key === 'ArrowUp') {
          if (!hasResults) return
          e.preventDefault()
          const currentIndexOfUp = this.highlightIndexOfKeyboard !== -1 ? this.highlightIndexOfKeyboard : this.highlightIndex
          this.highlightIndexOfKeyboard = currentIndexOfUp <= 0
          ? this.searchResults.length - 1
          : currentIndexOfUp - 1
          this.highlightIndex = -1 // 取消默认第一条高亮
          this.scrollIntoHighlight()
          return
        }
        if (e.key === 'Enter') {
          if (!this.searchKey || !this.searchResults.length) return
          e.preventDefault()
          const item = this.searchResults[this.highlightIndexOfKeyboard >= 0 ? this.highlightIndexOfKeyboard : 0]
          item && this.selectMenu(item)
          if (item.userChooseFlag) {
            this.highlightIndexOfKeyboard = -1
            this.$refs.searchMenu.blur()
          }
        }
        const isSearchShortcut = (e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')
        if (isSearchShortcut) {
          e.preventDefault()
          this.focusSearch()
        }
      },
      /** 将键盘高亮项滚动到可视区域内 */
      scrollIntoHighlight () {
        this.$nextTick(() => {
          const listEl = this.$refs.searchResultsList
          if (!listEl) return
          const items = listEl.querySelectorAll('.search-result-item')
          const activeItem = items[this.highlightIndexOfKeyboard]
          if (activeItem) {
            activeItem.scrollIntoView({ block: 'nearest' })
          }
        })
      },
      openLink (path) {
        const token = getToken()
        path = `${path}${path.includes('?') ? '&' : '?'}token=${token}`
        const dom = this.$refs.href
        dom.setAttribute('href', path)
        dom.dispatchEvent(new MouseEvent('click'))
      },
      goApplyAuth (item) {
        this.$router.push({
          path: '/oa/workflow/new-application/QXSQ-0003',
          query: {
            menuId: item.id,
            menuName: item.$title, // 要传 菜单路由
            applyType: 'add'
          }
        })
        this.visible = false
      }
    }
  }
</script>

<style lang="scss">
  .kye-header-search {
    width: 100%;
    &__input {
      width: 100%;
      .el-input__inner {
        padding-right: 8px!important;
        color: var(--g-theme-color-text)!important;
        background: var(--g-theme-search-bg)!important;
        padding-left: 30px!important;
        border-radius: 6px!important;
        border-color: var(--g-theme-search-border)!important;
        &:focus {
          border-color: var(--g-theme-search-border-focus)!important;
        }
        &::placeholder {
          color: var(--g-theme-placeholder-color);
        }
      }
      .el-input__prefix {
        top: 5px;
        padding-left: 4px;
        left: 8px;
        font-size: 14px;
        color: var(--g-theme-placeholder-color);
      }
    }
  }
  .kye-header-search-popover {
    padding: 16px 0 16px 0;
    box-sizing: border-box;
    border-radius: 12px;
    width: 500px !important;
    &-content {
      width: 100%;
    }
    .empty-box {
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 12px;
      color: rgba(136, 142, 166, 1);
      margin-bottom: 16px;
    }
    .search-history {
      padding: 0 16px;
      .search-history-title {
        font-size: 12px;
        color: rgba(136, 142, 166, 1);
        margin-bottom: 16px;
        .el-icon-delete {
          cursor: pointer;
        }
      }
      .search-history-list {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        overflow: hidden;
        .search-history-item {
          border-radius: 14px;
          height: 28px;
          line-height: 28px;
          padding: 0 16px;
          max-width: 160px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: rgba(69, 60, 90, 1);
          background: rgba(247, 248, 252, 1);
          cursor: pointer;
          &:hover {
            background: rgba(240, 240, 252, 1);
          }
        }
      }
    }
    .search-results {
      display: flex;
      flex-direction: column;
      max-height: 200px;
      overflow-y: auto;
      .search-result-item {
        height: 36px;
        display: flex;
        flex-shrink: 0;
        min-height: 36px;
        padding: 0 16px;
        font-size: 14px;
        cursor: pointer;
        align-items: center;
        color: #453C5A;
        &:hover,
        &--active {
          background: #F7F7FF;
        }
        .layout-search2 {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          line-height: 1;
          font-size: 13px;
          color: #68607B;
          margin-right: 10px;
        }
        &:not(.search-result-item--no-auth) {
          .title {
            flex: 1;
            min-width: 0;
            display: flex;
            align-items: center;
            overflow: hidden;
          }
        }
        .title {
          margin: 0;
          line-height: 1.2;
          // flex: 1;
          // min-width: 0;
          display: flex;
          align-items: center;
          overflow: hidden;
          .matched-keyword {
            margin-left: 2px;
            color: #A09EBF;
            display: inline-flex;
            align-items: center;
            // max-width: 40%;
            min-width: 0;
            flex: 1;
            &__paren {
              flex-shrink: 0;
            }
            &__text {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              min-width: 0;
            }
          }
          .search-highlight {
            color: var(--g-color-primary);
            // font-weight: 600;
          }
        }
        &--no-auth {
          .title {
            color: #A09EBF !important;
          }
          .no-auth {
            color: #FF9900;
            margin-left: 16px;
            margin-right: 8px;
            flex-shrink: 0;
          }
          .apply-auth {
            flex-shrink: 0;
            width: 84px;
            height: 24px;
            line-height: 24px;
            box-sizing: border-box;
            color: #6D2EF8;
            cursor: pointer;
            text-align: center;
            border-radius: 12px;
            font-size: 12px;
            background: rgba(121, 83, 246, 0.1);
          }
        }
      }
    }
    .module-box {
      padding: 0 16px;
      margin-top: 24px;
      .module-box-title {
        font-size: 12px;
        color: rgba(136, 142, 166, 1);
        margin: 10px 0;
      }
      .module-box-list {
        height: 300px;
        overflow: hidden;
      }
    }
  }
  .header-search-history-tooltip {
    &.is-light {
      border: 1px solid rgba(221, 226, 233, 1);
      box-shadow: 0 2px 8px rgba(28, 30, 35, 0.08);
      color: #333;
      font-size: 12px;
      line-height: 18px;
      max-width: 320px;
      word-break: break-all;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/header-search.vue